import {Box, Show, VStack,} from '@chakra-ui/react'
import {NavLink} from "react-router";
import {useRecoilState} from "recoil";
import {companiesData, executorData, userData, userLoginResultData} from "./hooks/recoilData";

export const Menu = () => {
    const [user] = useRecoilState(userData);
    const [executor] = useRecoilState(executorData);
    // const [company] = useRecoilState(companyData);
    const [companies] = useRecoilState(companiesData);
    const [userLoginResult] = useRecoilState(userLoginResultData);
    return user ? (
        <Box p={4} borderWidth={1}>
            <VStack>
                <NavLink to="/lk">Главная</NavLink>
                <Show when={userLoginResult && (userLoginResult.isEmployer || userLoginResult.isOperator || userLoginResult.isExecutor)}>
                    <NavLink to="/doc">Документы</NavLink>
                </Show>
                <Show when={userLoginResult && userLoginResult.isExecutor && executor}>
                    <NavLink to="/withdraw">Реквизиты</NavLink>
                    <NavLink to="/employer">Работодатели</NavLink>
                    <NavLink to="/task">Задачи</NavLink>
                </Show>
                <Show
                    when={userLoginResult && companies && (userLoginResult.isEmployer || userLoginResult.isOperator)}>
                    <NavLink to="/executor">Исполнители</NavLink>
                    <NavLink to="/task">Задачи</NavLink>
                    <NavLink to="/payout">Выплаты</NavLink>
                    <NavLink to="/template">Шаблоны</NavLink>
                    <NavLink to="/companyinfo">Компания</NavLink>
                    <NavLink to="/history">История</NavLink>
                </Show>
            </VStack>
        </Box>
    ) : (
        <></>
    )
};

